import { createImmerReducer } from 'ngrx-immer/store';
import { on } from '@ngrx/store';

import ProductCatalogActions from './product-catalog.actions';
import type { CatalogProductCard } from '@web/widgets/product-card/type/product-card-widget.type';
import { type CatalogCategory } from '@web/widgets/product-card/type/product-card-widget.type';

export const WEBSITE_CATALOG_FEATURE_KEY = 'catalog';

export type CatalogState = {
    categories: CatalogCategory[];
    products: CatalogProductCard[];
    selectedCategory: number;
    error?: string;
    isLoading?: boolean;
    isTariffExpired?: boolean;
    total?: number;
};

export const initialCatalogState: CatalogState = {
    categories: [],
    products: [],
    selectedCategory: null,
    isLoading: false,
    isTariffExpired: false,
    total: null,
};

export const productCatalogReducer = createImmerReducer<CatalogState>(
    initialCatalogState,
    on(
        ProductCatalogActions.loadCatalogContent,
        ProductCatalogActions.loadCategoriesRequest,
        ProductCatalogActions.loadProductsRequest,
        (state: CatalogState) => ({
            ...state,
            isLoading: true,
        })
    ),
    on(ProductCatalogActions.loadCategoriesSuccess, (state: CatalogState, { categories }) => ({
        ...state,
        categories,
        isLoading: false,
    })),
    on(ProductCatalogActions.loadCategoriesFailure, (state: CatalogState, { error }) => ({
        ...state,
        error,
    })),
    on(ProductCatalogActions.loadProductsSuccess, (state: CatalogState, { products, total }) => ({
        ...state,
        products,
        total,
        isLoading: false,
        isTariffExpired: false,
    })),
    on(ProductCatalogActions.loadProductsFailure, (state: CatalogState, { error }) => ({ ...state, error })),
    on(ProductCatalogActions.setTariffExpired, (state: CatalogState, { isTariffExpired }) => ({
        ...state,
        isTariffExpired,
    })),
    on(ProductCatalogActions.setCategory, (state: CatalogState, { category }) => ({
        ...state,
        selectedCategory: category,
    })),
    on(ProductCatalogActions.loadCatalogContentSuccess, (state: CatalogState, { categories, products }) => ({
        ...state,
        categories,
        products,
    }))
);
